import { Chip } from "primereact/chip";
import S from "./TagBrowser.module.scss";
import { languageDisplayNames, technologyDisplayNames } from "sj-ui-toolkit/src/constants";

const TagBrowser = ({
  technologies = [],
  languages = [],
  onTechnologySelect,
  onLanguageSelect,
  selectedTechnologies = [],
  selectedLanguages = [],
}) => {
  const handleTechClick = tech => {
    if (onTechnologySelect) {
      onTechnologySelect(tech);
    }
  };

  const handleLangClick = lang => {
    if (onLanguageSelect) {
      onLanguageSelect(lang);
    }
  };

  const isTechSelected = tech => selectedTechnologies.includes(tech);
  const isLangSelected = lang => selectedLanguages.includes(lang);

  return (
    <div className={S.tagBrowser}>
      <section className={S.tagSection}>
        <h3 className={S.sectionTitle}>Browse by Technology</h3>
        <div className={S.tagList}>
          {technologies.map(tech => (
            <Chip
              key={tech}
              label={technologyDisplayNames[tech] || tech}
              className={`${S.tagChip} ${isTechSelected(tech) ? S.selected : ""}`}
              onClick={() => handleTechClick(tech)}
            />
          ))}
        </div>
      </section>

      <section className={S.tagSection}>
        <h3 className={S.sectionTitle}>Browse by Language</h3>
        <div className={S.tagList}>
          {languages.map(lang => (
            <Chip
              key={lang}
              label={languageDisplayNames[lang] || lang}
              className={`${S.tagChip} ${S.languageChip} ${isLangSelected(lang) ? S.selected : ""}`}
              onClick={() => handleLangClick(lang)}
            />
          ))}
        </div>
      </section>
    </div>
  );
};

export default TagBrowser;
